import React, { Component } from 'react';
import { Thumbnail, Col, Button, Row, Table, Modal, Panel, OverlayTrigger, Tooltip, Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Field, reduxForm, initialize, reset, untouch } from "redux-form"
import NavHeader from './navheader'
import {
    updateCartProducts,
    checkCartProductsPrice,
    setDeliveryTime,
    showButtonUserInfoPage,
    clearCheckPriceResponse,
    updateCartExtraProducts,
    fetchExtraCartProducts,
    clearPromoCode,
} from '../actions'
import { getMoneyFormat } from '../utils'
import ProductItemOrderReview from './component_order_review_product_item'
import ProductCard from './order_review_product_card'
import OrderReviewFooter from './component_order_review_footer'
import DeliveryTime from './component_delivery_time'
import SubMenu from './submenu'
import Footer from './footer'
import Stepper from 'react-stepper-horizontal';
import _ from 'lodash'
class PageOrderReview extends Component {

    state = {
        showModal: false,
        showextraproductModal: false,
        showAlertDotModal: false,
        product_name: '',
        product_id: '',
        show_alert: false,
        loading: true,
        extraproduct_field1: null,
        extraproduct_field2: null,
        extraproduct_field3: null,
        extraproduct_field4: null,
        //tabSelected: 1,
        tabSelect: '1',
        user: JSON.parse(localStorage.getItem('user'))
    
    }

    componentWillMount() {
        if (localStorage.getItem('user') != null) {
            if (_.isEmpty(JSON.parse(localStorage.getItem('cart_products'))) || JSON.parse(localStorage.getItem('cart_products')) == null) {
                window.alert('ไม่มีรายการสินค้า')
                this.props.history.push('/')
            } else {
                let token = (JSON.parse(localStorage.getItem('user'))).token
                let products = { products: { ...(JSON.parse(localStorage.getItem('cart_products'))) } }
                this.props.checkCartProductsPrice(products, token, this.callbackErr.bind(this))
                this.props.setDeliveryTime('')
                let extraproducts = { products: { ...(JSON.parse(localStorage.getItem('extracart_products'))) } }
                this.props.fetchExtraCartProducts(extraproducts)
                this.props.clearPromoCode()
            }
        } else {
            this.props.showButtonUserInfoPage('show')
            this.props.history.push('/login')
        }
        window.scrollTo(0, 0)
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEmpty(nextProps.check_cart_products_price_response)
            && JSON.stringify(nextProps.check_cart_products_price_response) != JSON.stringify(this.props.check_cart_products_price_response)) {
            if (nextProps.check_cart_products_price_response.success) {
                this.setState({ loading: false })
            } else {
                let values = JSON.parse(JSON.stringify(this.props.cart_products))
                let products_changed = nextProps.check_cart_products_price_response.data.productsa
                _.map(products_changed, product => {
                    if (product.is_out_of_stock == true) {
                        delete values[product.id]
                    } else {
                        values[product.id]['product_price_unit'] = product.product_price_unit
                    }
                })
                this.props.updateCartProducts(values)
                this.setState({ loading: false })
                window.alert('สินค้าในตะกร้ามีารเปลี่ยนแปลงราคา หรือ หมดชั่วคราว กรุณาตรวจสอบรายการสินค้าในตะกร้าอีกครั้ง')
            }
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    componentWillUnmount() {
        this.props.clearCheckPriceResponse()
    }

    callbackErr() {
        window.alert('เกิดข้อผิดพลาด กรุณาทำรายการใหม่อีกครั้ง')
        this.props.history.push('/')
    }

    setShowAlert(bool) {
        this.setState({ show_alert: bool })
    }

    renderProducts() {
        let id = 0
        return _.map(this.props.cart_products, product => {
            return (
                <ProductCard key={id++}
                    product_id={product.product_id}
                    product_name={product.product_name} product_price={product.product_price}
                    product_amount={product.product_amount}
                    product_price_unit={product.product_price_unit}
                    product_image_url={product.product_image_url}
                    product_description={product.product_description}
                    product_unit={product.product_unit}
                    setOrderReviewPageState={this.setOrderReviewPageState.bind(this)} />
            )
        })
    }

    renderExtraProducts() {
        let id = 0
        return _.map(this.props.cart_extraproducts, (product, index) => {
            return (
                <tr key={id++} style={{ fontFamily: 'kanit !important' }}>
                    <td data-title="ชื่อสินค้า" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{product.product_name}</td>
                    <td data-title="จำนวน" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{product.product_amount}</td>
                    <td data-title="หน่วย" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{product.product_unit}</td>
                    <td data-title="ความต้องการเพิ่มเติม" style={{ textAlign: 'center', verticalAlign: 'middle' }}>{product.product_description}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <Button bsStyle='danger'
                            onClick={() => { this.onDeleteExtraproduct(product.product_name) }}>ลบ</Button></td>
                </tr>
            )
        })
    }

    handleInputErr(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        products[product_id]['product_amount'] = 1
        this.props.updateCartProducts(products)
    }

    setOrderReviewPageState(newState) {
        this.setState({ ...newState })
    }

    onDelete(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_products))
        delete products[product_id]
        this.props.updateCartProducts(products)
    }

    onDeleteExtraproduct(product_id) {
        let products = JSON.parse(JSON.stringify(this.props.cart_extraproducts))
        delete products[product_id]
        this.props.updateCartExtraProducts(products)
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className} style={{ marginBottom: 0 + '!important' }}>
                <input placeholder={field.placeholder} className="form-control" type={field.type} disabled={field.disabled} {...field.input} />
            </div>
        );
    }

    renderStepInputField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className} style={{ marginBottom: 0 + '!important' }}>
                <input placeholder={field.placeholder} className="form-control"
                    type={field.type} disabled={field.disabled}
                    min={field.min}
                    max={field.max}
                    step={field.step}
                    {...field.input} />
            </div>
        );
    }
    onSubmit(values) {
        if (values.productname_extraproduct.indexOf('.') !== -1) {
            this.setState({ showAlertDotModal: true })
        }
        else {
            this.state.extraproduct_field1 = null
            this.state.extraproduct_field2 = null
            this.state.extraproduct_field3 = null
            this.state.extraproduct_field4 = null
            this.props.dispatch(reset('Addextraproduct'));

            let products = JSON.parse(localStorage.getItem('extracart_products'))

            let product_id = values.productname_extraproduct
            let product_name = values.productname_extraproduct
            let product_amount = Number(values.amount_extraproduct)
            let product_price_unit = 0
            let product_image_url = "../static/images/extraproduct.png"
            let product_unit = values.unit_extraproduct
            let product_description = values.comment_extraproduct

            if (products != null) {
                if (products[product_id]) {
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: Number(products[product_id]['product_price_unit']),
                        product_amount: Number((Number(products[product_id]['product_amount']) + product_amount).toFixed(12)),
                        product_image_url: product_image_url,
                        product_unit: product_unit,
                        product_description: product_description
                    }
                } else {
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: product_price_unit,
                        product_amount: product_amount,
                        product_image_url: product_image_url,
                        product_unit: product_unit,
                        product_description: product_description
                    }
                }
            } else {
                products = {}
                products[product_id] = {
                    product_id: product_id,
                    product_name: product_name,
                    product_price_unit: product_price_unit,
                    product_amount: product_amount,
                    product_image_url: product_image_url,
                    product_unit: product_unit,
                    product_description: product_description
                }
            }

            localStorage.setItem('extracart_products', JSON.stringify(products))

            this.props.updateCartExtraProducts(products)
        }
    }
    onKeyPress(event) {
        if (event.which === 13) {
            event.preventDefault();
        }
    }
    handleextraproductbtn() {
        this.setState(prevState => ({
            showextraproductModal: !prevState.showextraproductModal
        }));
    }
    handleSelect(eventKey) {
        eventKey.preventDefault()
        this.setState({ tabSelect: eventKey })
    }

    handleChange(e) {
            this.setState({ tabSelect: e, showModal: false })
            this.renderTimeSlot()
        
    }
    renderTab() {
        let color1 = this.state.tabSelect == '1' ? '#6ac259' : ''
        let color2 = this.state.tabSelect == '2' ? '#F21B1B' : ''
       
        return (
            <div>
                <br />
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <Panel style={{ cursor: 'pointer', borderColor: color1 }} onClick={() => { this.handleChange('1') }}>
                            {this.state.tabSelect == '1' ?
                                <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                : <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 style={{ display: 'inline-block' }}>เข้าร่วมกิจกรรมเสาร์นี้มีเฮ</h5>
                        </Panel>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <Panel style={{ cursor: 'pointer', borderColor: color2 }} onClick={() => { this.handleChange('2') }}>
                            {this.state.tabSelect == '2' ?
                                 <img style={{ display: 'inline-block' }} src='../../static/images/checked.png' style={{ width: 25, marginRight: 8 }} />
                                : <img style={{ display: 'inline-block' }} src='../../static/images/checked02.png' style={{ width: 25, marginRight: 8 }} />}
                            <h5 style={{ display: 'inline-block' }}>ไม่เข้าร่วมกิจกรรมเสาร์นี้มีเฮ</h5>
                        </Panel>
                    </Col>
                </Row>
            </div>
        )
    }
    renderTimeSlot() {
               return (
               
            this.renderTimeSlotNoEven()
            )
        // if(this.state.tabSelect == '1'){
        //     return (
              
        //     this.renderTimeSlotEven()
        //     )
        // }else
        // {
        //     return (
               
        //     this.renderTimeSlotNoEven()
        //     )
        // }
    }
    renderTimeSlotNoEven() {
        return (
                <DeliveryTime show_alert={this.state.show_alert} />
        )
    }
    renderTimeSlotEven() {
        return (
            <DeliveryTime preorder show_alert={this.state.show_alert} />
        )
    }
    render() {
        const { handleSubmit } = this.props;
        const tooltip = (
            <Tooltip id="tooltip"><strong>รู้หรือไม่ !</strong> คุณสามารถสั่งสินค้าที่ไม่มีอยู่ในเว็บไซต์ได้ผู้ซื้อส่วนตัวจะทำการจัดหาสิ่งที่ท่านต้องการให้ หากสินค้าไม่มีทางพนักงานจะติดต่อท่านกลับไป</Tooltip>
        );
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <Col md={2} sm={12} xs={12}>

                    </Col>
                    <Col md={8} sm={12} xs={12}>
                        <div>
                            <Stepper
                                activeColor='#F37232'
                                completeColor='#F37232'
                                circleFontSize={14}
                                circleTop={15}
                                size={30}
                                steps={[{ title: 'ตรวจสอบรายการสินค้าในตะกร้า' },
                                { title: 'เลือกวิธีจัดส่ง' },
                                { title: 'วิธีชำระเงิน' },
                                { title: 'สั่งซื้อเรียบร้อย' }]}
                                activeStep={0} />
                        </div>
                        <div><span className="glyphicon glyphicon-shopping-cart" style={{ display: 'inline-block' }}> </span><h3 style={{ display: 'inline-block', marginLeft: 12 }}>รายการสินค้าในตะกร้า</h3></div>

                        {this.state.loading ? <div className='loader'></div> :
                            <div>
                                {this.renderProducts()}
                                <h3 style={{ display: 'inline-block' }}>สั่งสินค้าที่ไม่มีในเว็บไซต์ &nbsp;</h3>
                                {/* <OverlayTrigger placement="right" overlay={tooltip}>
                                        <span className="glyphicon glyphicon-info-sign" style={{ display: 'inline-block' }}>
                                        </span>
                                    </OverlayTrigger> */}
                                <h4 style={{ marginBottom: 15, color: '#898989' }}><strong>รู้หรือไม่!</strong></h4><p style={{ fontFamily: 'kanit !important', color: '#898989' }}>คุณสามารถสั่งสินค้าที่ไม่มีอยู่ในเว็บไซต์ได้ ผู้คัดสรรส่วนตัวจะทำการจัดหาสิ่งที่ท่านต้องการให้<br />หากไม่มีสินค้าทางพนักงานจะติดต่อท่านกลับไป</p>
                                <div>
                                    <form onKeyPress={this.onKeyPress} onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                                        <div id="no-more-tables">
                                            <table className="col-md-12 col-sm-12 col-lg-12 table-bordered table-striped table-condensed cf">
                                                <thead className="cf">
                                                    <tr>
                                                        <th className='numeric'>กรอกชื่อสินค้า</th>
                                                        <th className='numeric'>จำนวน</th>
                                                        <th className='numeric'>หน่วย</th>
                                                        <th className='numeric'>ความต้องการเพิ่มเติม</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.renderExtraProducts()}
                                                    <tr>
                                                        <td data-title="กรอกชื่อสินค้า">
                                                            <Field
                                                                placeholder="ชื่อสินค้า"
                                                                name="productname_extraproduct"
                                                                type="text"
                                                                component={this.renderInputField}
                                                                onSubmit={this.props.handleSubmit}
                                                                onChange={(e) => { this.setState({ extraproduct_field1: e.target.value }) }}
                                                            />
                                                        </td>
                                                        <td data-title="จำนวน">
                                                            <Field
                                                                placeholder="จำนวน"
                                                                name="amount_extraproduct"
                                                                type="number"
                                                                step={0.1}
                                                                min={0}
                                                                max={100}
                                                                component={this.renderStepInputField}
                                                                onSubmit={this.props.handleSubmit}
                                                                onChange={(e) => { this.setState({ extraproduct_field2: e.target.value }) }}
                                                            />
                                                        </td>
                                                        <td data-title="หน่วย">
                                                            <Field
                                                                placeholder="หน่วย"
                                                                name="unit_extraproduct"
                                                                type="text"
                                                                component={this.renderInputField}
                                                                onSubmit={this.props.handleSubmit}
                                                                onChange={(e) => { this.setState({ extraproduct_field3: e.target.value }) }}
                                                            />
                                                        </td>
                                                        <td data-title="ความต้องการเพิ่ม">
                                                            <Field
                                                                placeholder="กรอกความต้องการเพิ่มเติม"
                                                                name="comment_extraproduct"
                                                                type="text"
                                                                component={this.renderInputField}
                                                                onSubmit={this.props.handleSubmit}
                                                                onChange={(e) => { this.setState({ extraproduct_field4: e.target.value }) }}
                                                            />
                                                        </td>
                                                        <td data-title="">
                                                            <Button style={{ width: 100 + '%' }} bsStyle='success' type="submit"
                                                                disabled={
                                                                    !(this.state.extraproduct_field1 === "" || this.state.extraproduct_field1 == null || this.state.extraproduct_field1 == undefined
                                                                        ? false
                                                                        : true
                                                                            && this.state.extraproduct_field2 === "" || this.state.extraproduct_field2 == null || this.state.extraproduct_field2 == undefined
                                                                            ? false
                                                                            : true
                                                                                && this.state.extraproduct_field3 === "" || this.state.extraproduct_field3 == null || this.state.extraproduct_field3 == undefined
                                                                                ? false
                                                                                : true)
                                                                }>เพิ่มสินค้า</Button></td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>

                                                </tfoot>
                                            </table>
                                        </div>
                                    </form>
                                </div>
                                <div>&nbsp;</div>
                                {/* {this.renderTab()} */}
                                {this.renderTimeSlot()}
                                <br />
                                <OrderReviewFooter setShowAlert={this.setShowAlert.bind(this)} products={this.props.cart_products}
                                    extraproducts={this.props.cart_extraproducts}
                                    history={this.props.history} />
                            </div>
                        }

                    </Col>
                    {/* Modal */}
                    <Modal show={this.state.showModal}>
                        <Modal.Header>
                            <Modal.Title>ต้องการลบสินค้า {this.state.product_name} ออกจะตะกร้าใช่หรือไม่ ?</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button bsStyle="danger" onClick={() => {
                                this.onDelete(this.state.product_id); this.setState({ showModal: false })
                            }}>ลบออก</Button>
                            <Button bsStyle="primary" onClick={() => {
                                this.setState({ showModal: false })
                                if (this.props.cart_products[this.state.product_id].product_amount == '' || this.props.cart_products[this.state.product_id].product_amount == 0) {
                                    this.handleInputErr(this.state.product_id)
                                }
                            }}>ยกเลิก</Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal */}

                    {/* Alert Modal */}
                    <Modal show={this.state.showAlertDotModal}>
                        <Modal.Header>
                            <Modal.Title>เกิดข้อผิดพลาด กรุณาตรวจสอบว่าชื่อสินค้า ไม่ได้มี . อยู่ด้วย</Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button bsStyle="primary" onClick={() => {
                                this.setState({ showAlertDotModal: false })
                            }}>ตกลง</Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal */}

                </div>
                <Footer history={this.props.history} />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        cart_products: state.cart_products_reducer,
        cart_extraproducts: state.cart_extraproducts_reducer,
        check_cart_products_price_response: state.check_cart_products_price_response_reducer
    }
}
let InitializeFromStateForm = reduxForm({
    form: 'Addextraproduct',
})(PageOrderReview);

InitializeFromStateForm = connect(mapStateToProps,
    {
        updateCartProducts,
        checkCartProductsPrice,
        setDeliveryTime,
        showButtonUserInfoPage,
        clearCheckPriceResponse,
        fetchExtraCartProducts,
        updateCartExtraProducts,
        clearPromoCode,
    })
    (InitializeFromStateForm);

export default InitializeFromStateForm;


// WEBPACK FOOTER //
// ./src/components/page_order_review.js